export enum UserPermissionType {
  notSet = 'NotSet',
  ManageShop = 'ManageShop'
}
